export default "__VITE_ASSET__DcGFEPey__"